/*
 * 模块: SKUDetailHeader
 * 职责: SKU详情页头部操作栏
 * 依赖: react-router-dom, antd
 * 导出: SKUDetailHeader
 * 限制: 文件<100行, 函数<30行
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  DeleteOutlined,
  ReloadOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { PageHeader } from '../Layout/PageHeader';

interface SKUDetailHeaderProps {
  skuId: string;
  skuName: string;
  onReload: () => void;
  onDelete: () => void;
}

/**
 * SKU详情页头部组件
 * 包含返回按钮、标题和操作按钮组
 */
export const SKUDetailHeader: React.FC<SKUDetailHeaderProps> = ({
  skuId,
  skuName,
  onReload,
  onDelete,
}) => {
  const navigate = useNavigate();

  // 直接跳转到配置页面（不再需要下拉菜单）
  const handleConfigClick = () => {
    navigate(`/analysis/${skuId}/config`);
  };

  return (
    <PageHeader
      title={skuName}
      subtitle="产品数据分析详情"
      breadcrumbs={[
        { title: '首页', href: '/' },
        { title: '数据分析', href: '/aba-analysis' },
        { title: skuName },
      ]}
      onBack={() => navigate('/aba-analysis')}
      actions={[
        {
          key: 'reload',
          label: '刷新',
          icon: <ReloadOutlined />,
          onClick: onReload,
        },
        {
          key: 'config',
          label: '配置管理',
          type: 'default',
          icon: <SettingOutlined />,
          onClick: handleConfigClick,
        },
        {
          key: 'delete',
          label: '删除',
          danger: true,
          icon: <DeleteOutlined />,
          onClick: onDelete,
        },
      ]}
    />
  );
};

